/** Публичная справка продавца на основном домене (открывается из кабинета в новой вкладке). */
const SITE_ORIGIN = (
  import.meta.env.VITE_PUBLIC_SITE_URL || 'https://lavka-cvetov.com'
).replace(/\/$/, '');

export function sellerHelpUrl(questionId?: string | null): string {
  const url = new URL(`${SITE_ORIGIN}/seller-help`);
  if (questionId) {
    url.searchParams.set('q', questionId);
  }
  return url.toString();
}

export function openSellerHelp(questionId?: string | null): void {
  window.open(sellerHelpUrl(questionId), '_blank', 'noopener,noreferrer');
}

/** Политика конфиденциальности на лендинге продавцов. */
export function sellerPrivacyPolicyUrl(): string {
  return `${SITE_ORIGIN}/seller-privacy-policy`;
}

/** Согласие на рекламную рассылку на лендинге продавцов. */
export function sellerAdvertisingConsentUrl(): string {
  return `${SITE_ORIGIN}/seller-advertising-consent`;
}
